'use strict';

angular.module('jotApp')
    .directive('contentHeigthSync', function($timeout) {
        return {
            restrict: 'A',
            link: function(scope, elem) {
                elem.bind('click', function(e) {
                    $timeout(function(){
                        var sidebarHeight = $('.page-sidebar').innerHeight();
                        var pageContentHeight = $('.page-content').innerHeight();
                        if (sidebarHeight > pageContentHeight) {
                            $('.page-content').animate({
                                height: sidebarHeight
                            }, 200);
                        }
                        else {
                            $('.page-content').innerHeight('auto');
                        }
                    },300);
                });
            }
        };
    });
